"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COALESCE = void 0;
const tab_1 = require("../../../tab");
exports.COALESCE = {
    description: 'returns the first non empty value it finds',
    arg_names: ['col1', 'fallback'],
    args_def: [
        {
            types: ['string', 'boolean', 'date', 'int', 'number', 'column'],
            required: true,
        },
        {
            types: ['string', 'boolean', 'date', 'int', 'number', 'column'],
            required: true,
            variadic: true,
        },
    ],
    args_description: ['possibly null value', '...other possibly null values'],
    return_type: tab_1.ColumnType.STRING, // can be any type...
};
